<ui-modal
  class="spot-spot-matrix-modal modal-dialog modal-xl"
  [isOpened]="isModalOpened"
  modalTitle="Spot Spot Matrix"
  size="xl"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="body">
    <div class="main" *ngIf="page === 0">
      <form [formGroup]="form" (ngSubmit)="submit()" autocomplete="off">
        <div class="top-row">
          <ng-container formGroupName="first">
            <label class="ccy-container">
              Currency Pair
              <div class="ccy-select-container">
                <app-selector
                  class="currency-pair"
                  formControlName="cross"
                  [passedItems]="firstCrossOptions"
                ></app-selector>
              </div>
            </label>

            <label class="data-label">
              Min Spot
              <input
                class="clr-input"
                type="number"
                name="minSpot"
                formControlName="minSpot"
              />
            </label>

            <label class="data-label">
              Max Spot
              <input
                class="clr-input"
                type="number"
                formControlName="maxSpot"
              />
            </label>
            <label class="data-label">
              Number of Points
              <input
                class="clr-input"
                type="number"
                formControlName="numberOfPoints"
              />
            </label>
          </ng-container>
        </div>

        <div class="other-row">
          <ng-container formGroupName="second">
            <label class="ccy-container">
              Currency Pair
              <div class="ccy-select-container">
                <app-selector
                  class="currency-pair"
                  formControlName="cross"
                  [passedItems]="secondCrossOptions"
                ></app-selector>
              </div>
            </label>

            <label class="data-label">
              Min Spot
              <input
                class="clr-input"
                type="number"
                formControlName="minSpot"
              />
            </label>

            <label class="data-label">
              Max Spot
              <input
                class="clr-input"
                type="number"
                formControlName="maxSpot"
              />
            </label>
            <label class="data-label">
              Number of Points
              <input
                class="clr-input"
                type="number"
                formControlName="numberOfPoints"
              />
            </label>
          </ng-container>
        </div>
        <div class="other-row">
          <label class="ccy-container">
            Reporting currency
            <div class="ccy-select-container">
              <app-selector
                class="currency-pair"
                formControlName="reportingCurrency"
                [passedItems]="reportingCurrency"
              ></app-selector>
            </div>
          </label>
        </div>
        <hr class="hard-return" />

        <div class="modal-footer" style="display: flex; flex-direction: row">
          <button type="button" class="ui-button" (click)="modalChanged(false)">
            Cancel
          </button>
          <button
            class="ui-button primary"
            *ngIf="matrixResponse"
            (click)="page = 1"
            [disabled]="!matrixResponse"
          >
            View Calculated Matrix
          </button>
          <button
            type="submit"
            [disabled]="
              !this.form.valid ||
              !areLegsValid ||
              calculatingStatus.status === 'pending' ||
              calculatingStatus.status === 'webSocketDown'
            "
            class="ui-button primary modal-footer__calculate-button"
          >
            <div
              class="modal-footer__calculate-button__spinner-container"
              *ngIf="
                calculatingStatus.status === 'pending';
                else allowCalculating
              "
            >
              <span class="spinner spinner-sm spinner-inverse"> </span>
            </div>
            <ng-template #allowCalculating> Calculate </ng-template>
          </button>
        </div>
      </form>
    </div>

    <div class="table-container" *ngIf="page === 1 && matrixResponse">
      <div class="table-title">
        Indicative mark-to-market ({{ reportingCurrencyUsed }})
      </div>
      <table ui-table>
        <th></th>
        <th style="padding: 10px 0">
          {{
            (matrixResponse?.columnTitle | slice: 0:3) +
              '/' +
              (matrixResponse?.columnTitle | slice: 3:6)
          }}
        </th>

        <tbody>
          <th>
            <div class="y-axis-main-label">
              {{
                (matrixResponse?.lineTitle | slice: 0:3) +
                  '/' +
                  (matrixResponse?.lineTitle | slice: 3:6)
              }}
            </div>
          </th>

          <table ui-table id="table-data">
            <thead>
              <tr>
                <th></th>
                <th
                  class="x-axis-sub-label"
                  *ngFor="let label of matrixResponse.columnLabels"
                >
                  {{ label | number: '1.4-4' }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of matrixResponse.data">
                <th class="side-label-sub">
                  {{ row.label | number: '1.4-4' }}
                </th>
                <td
                  *ngFor="let rowValue of row.values"
                  [ngClass]="[
                    rowValue | valueColorsHeatMapSigned: minValue:maxValue
                  ]"
                >
                  {{ rowValue | number: '1.0-0' }}
                </td>
              </tr>
            </tbody>
          </table>
        </tbody>
      </table>
      <hr class="hard-return" />

      <div class="modal-footer">
        <button type="button" class="ui-button" (click)="modalChanged(false)">
          Cancel
        </button>

        <button
          type="button"
          class="ui-button primary"
          (click)="onCopyToClipboardClicked()"
        >
          Copy to Clipboard
        </button>

        <button class="ui-button primary" type="button" (click)="page = 0">
          Back to Setup
        </button>
      </div>
    </div>
    <!-- </div> -->
  </div>
</ui-modal>
